import { render } from "./PaginationClass.vue?vue&type=template&id=0b9ab472&scoped=true"
import script from "./PaginationClass.vue?vue&type=script&lang=js"
export * from "./PaginationClass.vue?vue&type=script&lang=js"

import "./PaginationClass.vue?vue&type=style&index=0&id=0b9ab472&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9ab472"]])

export default __exports__